/**
 * 目标 raster 图层解析（`interaction/tools/brush-tool.ts` 与
 * `app/path-stroke.ts` 共用，DESIGN.md §5.2/§7.1 补充）。
 *
 * 活动图层是 raster 就直接用；文档里还没有 raster 图层时自动建一层——
 * 跟真实 Photoshop"在空文档上直接画笔"的体验一致，不需要先手动新建
 * 图层。原来这段逻辑只写在 `BrushToolController` 内部，"描边路径"
 * （路径面板落笔）需要同一份行为，抽成共享函数而不是抄一遍。
 */
import { layerDefaults } from '../document/draft';
import { createAddLayerCommand } from './commands/layer-commands';
import type { RasterLayer } from '../document/types';
import type { LayerId } from '../engine/tile/key';
import type { AppStore } from './store';

export function ensureActiveRasterLayer(store: AppStore, nextLayerId: () => LayerId): LayerId | null {
  const document = store.document;
  if (document === null) return null;
  const active = store.activeRasterLayerId();
  if (active !== null) return active;

  const id = nextLayerId();
  const layer: RasterLayer = {
    ...layerDefaults(id, `图层 ${document.root.children.length + 1}`),
    kind: 'raster',
    tiles: store.tiles.handle(id),
    bounds: { x: 0, y: 0, width: 0, height: 0 },
  };
  store.dispatch(createAddLayerCommand({ layer, parentId: null, index: document.root.children.length }));
  store.setActiveLayer(id); // 新建即活动，与 PS 语义一致
  return id;
}
